import { FC } from "react";
import { Typography } from "@mui/material";
import { money as moneyConverter } from "../../../../../../../../utils/numeral/money";
import { TooltipText } from "../../../../../../../common/TooltipText";

interface MoneyCellRendererProps {
  approximate?: boolean;
  money?: number | null;
  billable?: string;
}

export const MoneyCellRenderer: FC<MoneyCellRendererProps> = ({
  money,
  billable,
  approximate,
}) => {
  if (money === null || money === undefined) {
    return <Typography variant="body2">N/A</Typography>;
  }

  if (billable === "no") {
    return <Typography variant="body2">N/A</Typography>;
  }

  const prefix = approximate ? "~" : "";
  const price = moneyConverter(money);

  if (money < 0.01 && money > 0) {
    return (
      <TooltipText tooltipTitle={`${prefix}$${money}`} variant="body2">
        {prefix}
        {price}
      </TooltipText>
    );
  }

  return (
    <Typography variant="body2">
      {prefix}
      {price}
    </Typography>
  );
};
